module.exports = __webpack_public_path__ + "img/s02-bg1.f165eb07.png";